import React from 'react';
import { HotelSection } from '../components';

const Hotels = () => {
  return (
    <HotelSection />
  );
};

export default Hotels;